"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationsPage = InvitationsPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var facility_management_1 = require("../components/dashboard/facility-management");
var invitations_1 = require("../components/dashboard/invitations");
var table_1 = require("../components/table");
var pagination_1 = require("../constants/pagination");
var client_invitation_1 = require("../features/apis/client-invitation");
var message_dialog_1 = require("../features/thunks/message-dialog");
var use_sort_descriptor_1 = require("../hooks/use-sort-descriptor");
var dialogs_1 = require("../interfaces/dialogs");
var hooks_1 = require("../store/hooks");
var api_error_message_1 = require("../utils/api-error-message");
var paginated_content_1 = require("../utils/paginated-content");
var use_debounce_1 = require("../utils/use-debounce");
var use_has_permission_1 = require("../utils/use-has-permission");
function InvitationsPage() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var userId = (0, hooks_1.useAppSelector)(function (state) { var _a; return (_a = state.user.user) === null || _a === void 0 ? void 0 : _a._uid; });
    var canInvite = (0, use_has_permission_1.useHasPermission)("create_client_invitations");
    var canManageInvitations = (0, use_has_permission_1.useHasPermission)("update_client_invitations");
    var _h = (0, react_1.useState)("ALL"), statusFilter = _h[0], setStatusFilter = _h[1];
    var _j = (0, react_1.useState)(""), search = _j[0], setSearch = _j[1];
    var debouncedSearch = (0, use_debounce_1.useDebouncedValue)(search);
    var _k = (0, react_1.useState)(pagination_1.DEFAULT_PAGE_NUMBER), page = _k[0], setPage = _k[1];
    var resetPage = (0, react_1.useCallback)(function () { return setPage(pagination_1.DEFAULT_PAGE_NUMBER); }, []);
    var _l = (0, use_sort_descriptor_1.useSortDescriptor)(resetPage), sortDescriptor = _l.sortDescriptor, onSortChange = _l.onSortChange, sortBy = _l.sortBy, sortDirection = _l.sortDirection;
    var _m = (0, react_1.useState)(pagination_1.DEFAULT_PAGE_SIZE), pageSize = _m[0], setPageSize = _m[1];
    var _o = (0, react_1.useState)(false), isInviteModalOpen = _o[0], setIsInviteModalOpen = _o[1];
    var _p = (0, react_1.useState)(new Set()), resendingInvitationIds = _p[0], setResendingInvitationIds = _p[1];
    var _q = (0, react_1.useState)(new Set()), cancellingInvitationIds = _q[0], setCancellingInvitationIds = _q[1];
    // Synchronous locks (checked before React re-renders the mutations' own loading state)
    // so a fast double-click on the same row can't fire the same action twice.
    var resendLockRef = (0, react_1.useRef)(new Set());
    var cancelLockRef = (0, react_1.useRef)(new Set());
    var statuses = statusFilter !== "ALL" ? [statusFilter] : undefined;
    var _r = (0, client_invitation_1.useGetClientInvitationsQuery)({ userId: userId !== null && userId !== void 0 ? userId : "", size: pageSize, pageNumber: page, search: debouncedSearch || undefined, statuses: statuses, sortBy: sortBy, sortDirection: sortDirection }, { skip: !userId }), data = _r.data, isLoading = _r.isLoading, isFetching = _r.isFetching, isError = _r.isError, error = _r.error, refetch = _r.refetch;
    var resendInvitation = (0, client_invitation_1.useResendInvitationMutation)()[0];
    var cancelInvitation = (0, client_invitation_1.useCancelInvitationMutation)()[0];
    var invitations = (0, paginated_content_1.getContentItems)(data);
    (0, react_1.useEffect)(function () {
        setPage(pagination_1.DEFAULT_PAGE_NUMBER);
    }, [statusFilter, debouncedSearch, pageSize]);
    var totalsByStatus = (_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.totalsByStatus;
    var sentCount = (_b = totalsByStatus === null || totalsByStatus === void 0 ? void 0 : totalsByStatus.SENT) !== null && _b !== void 0 ? _b : 0;
    var acceptedCount = (_c = totalsByStatus === null || totalsByStatus === void 0 ? void 0 : totalsByStatus.ACCEPTED) !== null && _c !== void 0 ? _c : 0;
    var cancelledCount = (_d = totalsByStatus === null || totalsByStatus === void 0 ? void 0 : totalsByStatus.CANCELLED) !== null && _d !== void 0 ? _d : 0;
    var totalCount = sentCount + acceptedCount + cancelledCount;
    var totalInvitations = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.content) === null || _e === void 0 ? void 0 : _e.pagination) === null || _f === void 0 ? void 0 : _f.totalItems) !== null && _g !== void 0 ? _g : invitations.length;
    var tabCounts = { ALL: totalCount, SENT: sentCount, ACCEPTED: acceptedCount, CANCELLED: cancelledCount };
    var summaryTiles = (0, react_1.useMemo)(function () { return [
        { label: "Total Invitations", value: String(totalCount), icon: "solar:letter-linear", tone: "primary" },
        { label: "Pending", value: String(sentCount), icon: "solar:clock-circle-linear", tone: "warning" },
        { label: "Accepted", value: String(acceptedCount), icon: "solar:check-circle-linear", tone: "success" },
        {
            label: "Acceptance Rate",
            value: totalCount ? "".concat(Math.round((acceptedCount / totalCount) * 100), "%") : "0%",
            icon: "solar:chart-2-linear",
            tone: "info",
        },
    ]; }, [totalCount, sentCount, acceptedCount]);
    var showActionFailure = function (header, body) {
        return dispatch((0, message_dialog_1.showMessageDialogThunk)({
            header: header,
            body: body,
            buttons: [{ type: dialogs_1.EMessageDialogButtonType.OK, label: "OK" }],
        })).catch(function () { });
    };
    var handleResend = function (invitation) { return __awaiter(_this, void 0, void 0, function () {
        var response, requestError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (resendLockRef.current.has(invitation.id)) {
                        return [2 /*return*/];
                    }
                    resendLockRef.current.add(invitation.id);
                    setResendingInvitationIds(new Set(resendLockRef.current));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 7, 8]);
                    return [4 /*yield*/, resendInvitation(invitation.id).unwrap()];
                case 2:
                    response = _a.sent();
                    if (!!response.success) return [3 /*break*/, 4];
                    return [4 /*yield*/, showActionFailure("Resend failed", response.message || "Unable to resend this invitation. Please try again.")];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 8];
                case 5:
                    requestError_1 = _a.sent();
                    return [4 /*yield*/, showActionFailure("Resend failed", (0, api_error_message_1.getApiErrorMessage)(requestError_1, "Unable to resend this invitation. Please try again."))];
                case 6:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 7:
                    resendLockRef.current.delete(invitation.id);
                    setResendingInvitationIds(new Set(resendLockRef.current));
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var handleCancel = function (invitation) { return __awaiter(_this, void 0, void 0, function () {
        var _a, response, requestError_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (cancelLockRef.current.has(invitation.id)) {
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch((0, message_dialog_1.showMessageDialogThunk)({
                            header: "Cancel invitation",
                            body: "Cancel the invitation for ".concat(invitation.email, "? This will invalidate its payment link and cannot be undone."),
                            buttons: [
                                { type: dialogs_1.EMessageDialogButtonType.CANCEL, label: "Keep Invitation", variant: "secondary" },
                                { type: dialogs_1.EMessageDialogButtonType.OK, label: "Cancel Invitation" },
                            ],
                        })).unwrap()];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/];
                case 4:
                    cancelLockRef.current.add(invitation.id);
                    setCancellingInvitationIds(new Set(cancelLockRef.current));
                    _b.label = 5;
                case 5:
                    _b.trys.push([5, 9, 11, 12]);
                    return [4 /*yield*/, cancelInvitation(invitation.id).unwrap()];
                case 6:
                    response = _b.sent();
                    if (!!response.success) return [3 /*break*/, 8];
                    return [4 /*yield*/, showActionFailure("Cancel failed", response.message || "Unable to cancel this invitation. Please try again.")];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8: return [3 /*break*/, 12];
                case 9:
                    requestError_2 = _b.sent();
                    return [4 /*yield*/, showActionFailure("Cancel failed", (0, api_error_message_1.getApiErrorMessage)(requestError_2, "Unable to cancel this invitation. Please try again."))];
                case 10:
                    _b.sent();
                    return [3 /*break*/, 12];
                case 11:
                    cancelLockRef.current.delete(invitation.id);
                    setCancellingInvitationIds(new Set(cancelLockRef.current));
                    return [7 /*endfinally*/];
                case 12: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-6", children: [(0, jsx_runtime_1.jsx)(facility_management_1.PageHeader, { title: "Client Invitations", subtitle: "Invite new clients and track the status of pending invitations.", searchValue: search, searchPlaceholder: "Search invitations...", addLabel: "Invite Client", onSearchChange: setSearch, onAdd: canInvite ? function () { return setIsInviteModalOpen(true); } : undefined }), (0, jsx_runtime_1.jsx)(invitations_1.InvitationsSummaryCards, { tiles: summaryTiles }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4 rounded-md border border-gray-200 bg-white p-4", children: [(0, jsx_runtime_1.jsx)(invitations_1.InvitationsTabs, { value: statusFilter, onChange: setStatusFilter, counts: tabCounts }), (0, jsx_runtime_1.jsx)(invitations_1.InvitationsTable, { invitations: invitations, isLoading: isLoading, isFetching: isFetching, isError: isError, error: error, onRetry: refetch, onResend: handleResend, onCancel: handleCancel, resendingInvitationIds: resendingInvitationIds, cancellingInvitationIds: cancellingInvitationIds, canManageInvitations: canManageInvitations, sortDescriptor: sortDescriptor, onSortChange: onSortChange }), (0, jsx_runtime_1.jsx)(table_1.Pagination, { page: page, pageSize: pageSize, total: totalInvitations, onPageChange: setPage, itemLabel: "invitations", onPageSizeChange: setPageSize })] }), (0, jsx_runtime_1.jsx)(invitations_1.InviteClientModal, { isOpen: isInviteModalOpen, onClose: function () { return setIsInviteModalOpen(false); }, onInvited: refetch })] }));
}
